import baseUrl from "../config/baseUrl";
const getUserDocumentsTimeSummary = async ({ token, userId }) => {
  try {
        const response = await fetch(`${baseUrl}/api/get-user-documents-timebased-summary?userId=${userId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getUserDocumentsTimeSummary;